import React, {Component} from 'react';
import {CardElement, PostalElement, injectStripe} from 'react-stripe-elements';
import {addNewPlan} from 'store/actions/billingActions';
import { connect } from 'react-redux'
import { compose } from 'redux'
import Select from 'react-select';

const createOptions = () => {
    return {
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#c23d4b',
        },
      }
    }
  };

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  
  async submit(ev) {
      
        ev.preventDefault();

        let {token} = await this.props.stripe.createToken({name: "Name"});
        if ((token.id !== null) && (token.id !== undefined)) {
          let companyName = this.props.companyName;
          let response = await fetch("https://construwise-qa.firebaseapp.com/confirmPay", {
              method: "POST",
              headers: {"Content-Type": "text/plain"},
              body: {'stripeToken': token.id, 'stripeTokenType': token.type, 'stripeEmail': '', companyName}
          });

          if (response.ok) console.log("CC verification Complete!")
          this.props.addNewPlan(ev.options);
        }
    }

    handlePlanChange = (e) => {
        this.setState({
          plan: e.value
        })
      }

  render() {
    let options = new Array();
    
    options.push({label: "Basic Plan - 9.99", value: "Basic"});
    options.push({label: "Extended Plan - 14.99", value: "Extended"});
    
    const customControlStyles = {
        control: (base, state) => ({
          ...base,
          minHeight: 32,
          height: 32,
          width: 300,
          background: "#ffffff",
          autoWidth: true,
          
          borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
          // Overwrittes the different states of border
          borderColor: state.isFocused ? "yellow" : "green",
          // Removes weird border around container
          boxShadow: state.isFocused ? null : null,
          "&:hover": {
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "yellow" : "green"
          },
          padding: "5px",
          margin: "5px",
        })
      };

    return (
      <div>
        <br/>
        <Select
          styles={customControlStyles}
          placeholder="Select A Plan Today ..."
          onChange={this.handlePlanChange}
          options={options}
          
          />
        <CardElement {...createOptions()}/>
        
        <button onClick={this.submit}>Verify Card</button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
    return {
      
          addNewPlan: (planName) => dispatch(addNewPlan(planName))
    }
  }

const mapStateToProps = (state, ownProps) => {
    console.log(state);
    
    return {
      auth: state.firebase.auth,
      companyName: state.project.companyName
    }
  }

export default compose(
    connect(mapStateToProps),
  )(injectStripe(CheckoutForm));


// WEBPACK FOOTER //
// ./src/components/billing/CheckoutForm.js